import { currentConfig } from "amplifyConfig";
import { urls } from '../../../urls';

export const fetchResetUserPassword = async (userName: string): Promise<Response> => {
    try {
        const userAdminUrl = urls.USER_ADMIN;
        let body = {
            username: userName,
            userPoolId: currentConfig.userPoolId
        }
        const resp = await fetch(`${userAdminUrl}/userAdmin/resetUserPassword`, {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body)
        })
        console.log("forgot password res: ", resp);

        return resp;

    } catch (e) {
        return new Response(
            JSON.stringify({ error: true, message: String(e) }),
            {
                status: 500,
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
    }
}